import React from "react";


export default function Clients(){
    return(
        <h1>clients</h1>
    )
}